export default "__VITE_ASSET__DuA9HSJp__"